<app-ax-table
	[displayedColumnsDesktop]="displayedColumnsDesktop"
	[displayedColumnsDesktopAdmin]="displayedColumnsAdmin"
	[isAdmin]="isSports"
	[columns]="columns"
	[data]="jobHistories"
	(rowClick)="showJobHistory($event)"
></app-ax-table>
